import { Box, Text } from '@chakra-ui/react';

const MaksabReports = () => {
  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="black"
    >
      <Text
        fontSize="8xl"
        fontWeight="bold"
        color="white"
      >
        SOON We work on it ...
      </Text>
    </Box>
  );
};

export default MaksabReports;